import { useGetPersonCategoryTreeSuspense } from "@/orval/gen"
import { TreePillsInput } from "@components/tree/tree-pills-input"
import { PillsInputProps } from "@mantine/core"
import { useTranslation } from "react-i18next"

interface PersonCategoryTreeSelectProps extends Omit<
  PillsInputProps,
  "value" | "onChange"
> {
  value?: string[] | null | undefined
  onChange?: (value: string[]) => void
}

export function PersonCategoryTreeSelect({
  value,
  onChange,
  ...props
}: PersonCategoryTreeSelectProps) {
  const { data: personCategoryTree } = useGetPersonCategoryTreeSuspense()
  const { t } = useTranslation("app_server")
  return (
    <TreePillsInput
      label={t("ContactArea")}
      tree={personCategoryTree.tree}
      initialCheckedState={value ?? []}
      onCheckedStateChange={onChange}
      initialExpandedState={personCategoryTree.initialExpandedState}
      {...props}
    />
  )
}
